import type { AssignableUserView } from '../api/generated/models/AssignableUserView';

const AVATAR_COLORS = [
  '#2563eb',
  '#7c3aed',
  '#db2777',
  '#ea580c',
  '#059669',
  '#0891b2',
  '#4f46e5',
  '#be123c',
] as const;

/** Deterministic avatar background from user id (same person, same color everywhere). */
export function assigneeAvatarColor(userId: string): string {
  let hash = 0;
  for (let i = 0; i < userId.length; i += 1) {
    hash = userId.charCodeAt(i) + ((hash << 5) - hash);
  }
  return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length];
}

export function assigneeDisplayName(
  member: Pick<AssignableUserView, 'name' | 'isSelf'>,
  t: (key: string) => string,
): string {
  const base = member.name?.trim() ?? '';
  if (member.isSelf) {
    return base ? `${base} (${t('tasks_assignee_you')})` : t('tasks_assignee_you');
  }
  return base;
}

/** Row sublabel per REACT_NOTIFICATIONS.md §3.2 (isOwner / isSelf are independent). */
export function assigneeRowSublabel(
  member: Pick<AssignableUserView, 'isOwner' | 'isSelf'>,
  t: (key: string) => string,
): string | null {
  if (member.isSelf && member.isOwner) {
    return null;
  }
  if (member.isOwner) {
    return t('tasks_assignee_parent');
  }
  return t('tasks_assignee_sub');
}

export function sameIdSet(a: string[], b: string[]): boolean {
  if (a.length !== b.length) {
    return false;
  }
  const sortedA = [...a].sort();
  const sortedB = [...b].sort();
  return sortedA.every((id, index) => id === sortedB[index]);
}
